import BaseApi from "apps/visits/lib/BaseApi";
import { createRoute } from "apps/visits/packages/shared/models/Route";
import { HTTPMethods } from "apps/visits/packages/shared/static/http-methods";
import type { AddressSuggestion } from "../models/address-suggestion";

export const routes = {
  getAddressSuggestions: createRoute("/api/v2/addresses/search"),
};

type AddressesResponse = {
  addresses: AddressSuggestion[];
};

export class AddressSuggestionsRepository extends BaseApi {
  async getSuggestions(query: string): Promise<AddressSuggestion[]> {
    const response = await this.request<AddressesResponse>({
      url: routes.getAddressSuggestions.raw(),
      method: HTTPMethods.GET,
      params: {
        query,
      },
    });

    return response.addresses || [];
  }
}

export const addressSuggestionsRepository = new AddressSuggestionsRepository();
